if (document.getElementById('vue-login')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-login',
		data: {
			form_fields: {
				email: {
					label: gettext('login (email)'),
					labelClasses: 'uppercase pb-10',
					validate: 'email',
					model: {}
				},
				password: {
					label: gettext('mot de passe'),
					labelClasses: 'uppercase pb-10',
					type: 'password',
					model: {}
				}
			},
			recaptchaToken: '',
		},
		created() {
			this.$validator.localize(gettext('fr'));
		},
		mounted() {
			let user = JSON.parse(localStorage.getItem('user'));
			let params = getQueryStringParameters();
			grecaptcha.ready(() => {
				this.reloadRecaptcha()
			})
			if (user) {
				if (user.role === 'resident') {
					if (user.status === 'tenant') {
						window.location.href = '/espace-personnel/paiements';
					} else if (user.status === 'candidate') {
						window.location.href = '/espace-personnel';
					} else {
						window.location.href = '/';
					}
				} else if (user.role === 'collaborator') {
					window.location.href = '/candidatures';
				}
			}
			if (params.hasOwnProperty('email')) {
				this.form_fields.email.model.value = params.email;
			}
		},
		methods: {
			reloadRecaptcha() {
				grecaptcha.execute('6LfYuz4qAAAAAHJkUmwQV9CB3O5-d9SoDOvVQJE-').then((token) => {
					this.recaptchaToken = token
				})
			},
			login(event) {
				event.preventDefault();
				this.reloadRecaptcha();
				this.$validator.validateAll().then((result) => {
					if (result) {
						let data = {
							recaptcha_token: this.recaptchaToken
						};
						Object.keys(this.form_fields).forEach((key) => {
							data[key] = this.form_fields[key].model.value;
						});
						this.post(window.site_url + '/api/v1/auth/login/', data, false, true)
							.then((response) => {
								localStorage.setItem('token', response.data.key);
								this.get('users/me')
									.then((response) => {
										localStorage.setItem('user', JSON.stringify(response.data));
										let params = getQueryStringParameters();
										if (params.hasOwnProperty('next')) {
											window.location.href = params.next;
										} else {
											if (response.data.role === 'resident') {
												if (response.data.status === 'tenant') {
													// window.location.href = '/espace-personnel/paiements';
													window.location.href = window.login_redirect_url_for_tenant;
												} else if (response.data.status === 'candidate') {
													// window.location.href = '/espace-personnel';
													window.location.href = window.login_redirect_url_for_candidate;
												} else {
													window.location.href = '/';
												}
											} else if (response.data.role === 'collaborator') {
												window.location.href = '/candidatures';
											} else {
												window.location.href = '/';
											}
										}
									})
									.catch((error) => {
										// console.log(error);
									});
							})
							.catch((error) => {
								Object.keys(error.response.data).map((el) => {
									this.errors.remove(el);
									this.errors.add({
										field: el,
										msg: error.response.data[el][0]
									});
								});
							});
					}
				});
			}
		}
	});
}
